// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__25dP0","checkboxCol":"Table_checkboxCol__3RaCj","emailCol":"Table_emailCol__DWh2Q","actionCol":"Table_actionCol__2ADnV"};